/* eslint-disable react/prop-types */
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Logo, LanguagePicker } from 'cosmos-components';
import styled from 'styled-components';

import { languageOptions } from 'src/constants';
import { getScreenBreaks } from 'src/utils/htmlHelper';
import { getLangCode } from 'src/utils/string';
import heroBanner from 'src/assets/images/hero-banner-new.jpg';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { sciLanguageSelector } from 'src/components/shared/SciPage/SciPage.selector';

import {
    StyledHeader,
    StyledHeroBanner,
    StyledDivider,
} from './Header';
import { title } from './messages';
import { DeviceType } from 'src/enums';
import { HeaderIcons } from './EMHeader';

export interface CAHeaderProps {
    hideBanner?: boolean;
}

export const CAHeader: FC<CAHeaderProps> = ({ hideBanner }) => {
    const { deviceType } = useWindowDimensions();
    const intl = useIntl();
    const [searchParams, setSearchParams] = useSearchParams();
    const language = getLangCode(useSelector(sciLanguageSelector));
    const initLanguage =
        languageOptions.find((opt) => opt?.label?.toLowerCase() === language) ||
        languageOptions[0];
    document.title = intl.formatMessage(title.title);

    return (
        <StyledHeader>
            <HeaderIcons id="header-icons" deviceType={deviceType}>
                <CaHeaderIconContainer>
                    <ColoredLogo name="coloredCanadream" deviceType={deviceType}/>
                </CaHeaderIconContainer>
                <LanguagePickerContainer key={language}>
                    <LanguagePicker
                        className="LanguagePicker"
                        testId="LanguagePicker"
                        initialValue={initLanguage}
                        options={languageOptions}
                        onOptionSelect={(selected) => {
                            searchParams.set(
                                'lng',
                                selected?.label?.toLowerCase(),
                            );
                            setSearchParams(searchParams);
                        }}
                    />
                </LanguagePickerContainer>
            </HeaderIcons>
            {!hideBanner && <StyledHeroBanner src={heroBanner} />}
            {!hideBanner && <StyledDivider />}
        </StyledHeader>
    );
};

const LanguagePickerContainer = styled.div`
    margin-left: auto;
    margin-right: 4rem;

    div.dropdown-options {
        @media (max-width: ${(props) => getScreenBreaks(props).screenMDMin}) {
            float: left;
            width: 9rem;
        }
    }

    input {
        min-width: 18px;
        min-width: 1.8rem;
    }
`;

const CaHeaderIconContainer = styled.div`
    min-height: 3.9rem;
    padding-bottom: 0.5rem;
`;

export const ColoredLogo = styled(Logo)<{ deviceType: DeviceType }>`
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '8rem' : '14rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '2.22rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1.5rem' : '0'};
`;
